import Vue from 'vue';
import Tour01 from '@/components/TourPlugin/Tour01';
import Tour02 from '@/components/TourPlugin/Tour02';
import Tour03 from '@/components/TourPlugin/Tour03';
import Tour04 from '@/components/TourPlugin/Tour04';
import Tour05 from '@/components/TourPlugin/Tour05';
import Tour06 from '@/components/TourPlugin/Tour06';

let popup = null;
let arrPopup = [];

export default {
    Tour01() {
        if (arrPopup.length > 0) {
            arrPopup.forEach(p => {
                p.$el.remove();
                p.$destroy();
            })

            arrPopup = []
        }

        const boxLeft = document.querySelector("#box-left");
        if (boxLeft) {
            const PopupClass = Vue.extend(Tour01);
            popup = new PopupClass();
            popup.close = () => {
                boxLeft.removeChild(popup.$el);
                popup.$destroy();
                popup = null;
            };
            popup.$mount();
            boxLeft.appendChild(popup.$el);
            arrPopup.push(popup);
        }
    },
    Tour02() {
        const boxLeft = document.querySelector("#box-left")
        if (boxLeft) {
            boxLeft.removeChild(popup.$el);
            popup.$destroy();
            popup = null;
        }

        const searchBox = document.querySelector("#search");
        if (searchBox) {
            const PopupClass = Vue.extend(Tour02);
            popup = new PopupClass();
            popup.close = () => {
                searchBox.removeChild(popup.$el);
                popup.$destroy();
                popup = null;
            };
            popup.$mount();
            searchBox.appendChild(popup.$el);
            arrPopup.push(popup);
        }
    },
    Tour03() {
        const searchBox = document.querySelector("#search");
        if(searchBox) {
            popup.$destroy();
            popup = null;
        }

        const notifyBox = document.querySelector("#notifications");
        if(notifyBox) {
            const PopupClass = Vue.extend(Tour03);
            popup = new PopupClass();
            popup.close = () => {
                notifyBox.removeChild(popup.$el);
                popup.$destroy();
                popup = null;
            };
            popup.$mount();
            notifyBox.appendChild(popup.$el);
            arrPopup.push(popup);
        }
    },
    Tour04() {
        document.querySelector("#notifications").removeChild(popup.$el);
        popup.$destroy();
        popup = null;

        const PopupClass = Vue.extend(Tour04);
        popup = new PopupClass();
        popup.close = () => {
            document.querySelector("#language").removeChild(popup.$el);
            popup.$destroy();
            popup = null;
        };
        popup.$mount();
        document.querySelector("#language").appendChild(popup.$el);
        arrPopup.push(popup);
    },
    Tour05() {
        document.querySelector("#language").removeChild(popup.$el);
        popup.$destroy();
        popup = null;

        const PopupClass = Vue.extend(Tour05);
        popup = new PopupClass();
        popup.close = () => {
            document.querySelector("#icon").removeChild(popup.$el);
            popup.$destroy();
            popup = null;
        };
        popup.$mount();
        document.querySelector("#icon").appendChild(popup.$el);
        arrPopup.push(popup);
    },
    Tour06() {
        document.querySelector("#icon").removeChild(popup.$el);
        popup.$destroy();
        popup = null;

        const PopupClass = Vue.extend(Tour06);
        popup = new PopupClass();
        popup.close = () => {
            document.querySelector("#box-left").removeChild(popup.$el);
            popup.$destroy();
            popup = null;
        };
        popup.$mount();
        document.querySelector("#box-left").appendChild(popup.$el);
        arrPopup.push(popup);
    }
};